var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.275 17.792h-3.433A1.042 1.042 0 0 1 10.8 16.75v-2.733H9.208v2.733c0 .575-.466 1.042-1.041 1.042H4.725a1.042 1.042 0 0 1-1.042-1.042V9.608h-.408c-.45 0-.833-.275-.983-.7a1.017 1.017 0 0 1 .341-1.158l6.725-5.317c.384-.3.917-.3 1.292 0l6.717 5.35c.35.284.483.734.333 1.159-.15.425-.533.7-.983.7h-.409v7.108c0 .575-.466 1.042-1.041 1.042h.008Zm-3.225-1.25h3.017V9.008a.624.624 0 0 1 .625-.625h.433l-6.117-4.875L3.883 8.35h.434a.63.63 0 0 1 .625.625v7.558h3.016v-3.15a.63.63 0 0 1 .625-.625h2.842a.63.63 0 0 1 .625.625v3.159Z",
    fill: "current"
  })));
};
export default SvgHome;